/* eslint-disable no-sequences */
import axios from "axios";
import { apiUrl_forPaymentIntegration } from "./constants";

const CancelToken = axios.CancelToken;

// get payment
export let cancelGetPaymnetIntegartionApi;
export async function getPaymnetIntegartion(headers, account_id) {
    if (headers && account_id) {
        const payments = await axios.get(
            apiUrl_forPaymentIntegration +
                "check/paymentIntegration/" +
                account_id,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetPaymnetIntegartionApi = c;
                }),
            }
        );
        return payments;
    } else {
        console.log("Please add required parameters");
    }
}
// add payment
export let cancelAddPaymentIntegrationApi;
export async function addPaymentIntegration(headers, data) {
    if ((headers && data)) {
        const payments = await axios.post(
            apiUrl_forPaymentIntegration + "check/paymentIntegration",
            data,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddPaymentIntegrationApi = c;
                }),
            }
        );
        return payments;
    } else {
        console.log("Please add required parameters");
    }
}

// update customer
export let cancelEditPaymentIntegrationApi;
export async function editPaymentINtegration(headers, account_id = "1") {
    if ((headers && account_id)) {
        const payments = await axios.post(
            apiUrl_forPaymentIntegration +
                "check/paymentIntegration?account_id=" +
                account_id,
            account_id,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditPaymentIntegrationApi = c;
                }),
            }
        );
        return payments;
    } else {
        console.log("Please add required parameters");
    }
}
